import ServiceStatsList from './ServiceStatsList';

export default {
    list: ServiceStatsList,
};
